module.exports = __webpack_public_path__ + "img/link_off.19fda765.svg";